import { Props } from '~/containers/AdditionalApplicantInfo/types';

function meetsDataDependencies(props: Props) {
  const { homeCoApplicant, autoCoApplicant } = props;

  return !!homeCoApplicant || !!autoCoApplicant;
}

const step = {
  route: '/homeowners-insurance/quotes/additional-applicant-info',
  isAccessible: ({
    homeCoApplicant,
    autoCoApplicant,
    application: { isAutoOnly },
  }: Props): boolean => !!homeCoApplicant || (!!autoCoApplicant && isAutoOnly),
  breadcrumbStep: 'applicants',
  meetsDataDependencies,
};

export default step;
